import React from 'react';
import CustomerPaymentModal from '../../components/payment/CustomerPaymentModal';

export default function InvoicePayModal(props) {
  return <CustomerPaymentModal {...props} invoice={props.invoice} />;
}
